/**
 * @ngdoc directive
 * @name flowHeader
 * @module flowingly.runner.flow
 * @description  This component is used to display a flow summary.
 * @usage
 * ```
     <flow-header ng-click="$ctrl.onClickMethod({ id: $ctrl.flow.id })" flow="$ctrl.flow" is-mobile="$ctrl.isMobile"></flow-header>
 * ``` 
 * ### Notes
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Angular+Flow+Components
 * ### Properties
 * #### Inputs
 * * flow: the flow data to display (JSON)
 * * isMobile: show mobile view if set
 */

import { SharedAngular } from '@Client/@types/sharedAngular';
import { RunnerFlowsFormatterService } from '@Client/runner.services/flows.formatter';
import IntegrationState from '@Shared.Angular/@types/core/contracts/queryModel/webhook/integrationState';
import angular from 'angular';

angular.module('flowingly.runner.flow').component('flowHeader', {
  bindings: {
    flow: '<',
    isMobile: '<' //show mobile view if set
  },

  controller: [
    'runnerFlowsFormatter',
    'APP_CONFIG',
    function (
      runnerFlowsFormatter: RunnerFlowsFormatterService,
      APP_CONFIG: SharedAngular.APP_CONFIG
    ) {
      const $ctrl = this;

      if (!$ctrl.flow) {
        return;
      }

      $ctrl.showConfidentialFlowOption = APP_CONFIG.showConfidentialFlowOption;
      $ctrl.progress = $ctrl.flow.percentageComplete;
      $ctrl.webhookIconPath = ASSETS_PATH + '/webhooks-icon.svg';
      $ctrl.flowHasProcessingWebhook =
        $ctrl.flow.integrationState === IntegrationState.Processing;

      // if converting to TS remember to replace this with @TODO Guid.Empty
      if (
        $ctrl.flow.flowId == '00000000-0000-0000-0000-000000000000' ||
        $ctrl.flow.flowId == null
      ) {
        $ctrl.startedByText = 'Started by';
      } else {
        $ctrl.startedByText = runnerFlowsFormatter.getStartedByText($ctrl.flow);
      }

      updateFileIcon();

      function updateFileIcon() {
        let count = 0;
        if ($ctrl.flow.steps) {
          for (let i = 0; i < $ctrl.flow.steps.length; i++) {
            const step = $ctrl.flow.steps[i];
            for (let j = 0; j < step.fields.length; j++) {
              const field = step.fields[j];
              if (field.hasFiles) {
                count++;
              } else if (field.type === 'table') {
                if (field.tableHasRows) {
                  const table = JSON.parse(field.text);
                  angular.forEach(table.rows, function (row) {
                    angular.forEach(row.cells, function (cell) {
                      if (cell.type === 4) {
                        if (cell.value) {
                          count++;
                        }
                      }
                    });
                  });
                }
              }
            }
          }
          $ctrl.flow.filesCount = count;
        }
      }
    }
  ],
  controllerAs: '$ctrl',
  templateUrl:
    'Client/runner.flow/runner.flow.header/runner.flow.header.component.tmpl.html'
});
